<template>
  <div class="menu menu-pc">
    <div class="logo-box">
      <router-link to="/"><img src="@/assets/img/Logo-AFCwave.png" /></router-link>
    </div>

    <ul class="menu-list">
      <template v-for="(item, index) in getMenuList">
        <li><router-link :to="item.link" :class="{active: currLink == index}">{{item.name}}</router-link></li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MenuPC',
  data() {
    return {
      currLink: 6,
      menulist: [{
        name: '首页',
        link: '/'
      },{
        name: '产品',
        link: '/products'
      },{
        name: '案例',
        link: '/solutions'
      }/*,{
        name: '培训',
        link: '/training'
      }*/,{
        name: '资源',
        link: '/resources'
      },{
        name: '简介',
        link: '/aboutus'
      },{
        name: '联系我们',
        link: '/contact'
      }]
    };
  },
  computed: {
    getMenuList: function (){
      return this.menulist.reverse();
    }
  },
  components: {
    
  },
  watch: {
    '$route'(v1, v2){
      this.currLink = this.getCurrLink();
    }
  },
  methods: {
    getCurrLink(){
      let currMenu = localStorage.getItem('currMenu');
      if(currMenu != null){
        return parseInt(currMenu);
      }
      return 0;
    }
  },
  created(){
    this.currLink = this.getCurrLink();
  }
};
</script>

<style lang="" scoped>
.menu{
  position: fixed;
  top: 40px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #FFF;
  z-index: 1000;
  border-bottom: 2px solid #edeeee;
}

.menu-pc{
  display: block;
}

.logo-box{
  display: inline-block;
  height: 80px;
  width: 300px;
  float: left;
  position: relative;
}

.logo-box img{
  display: block;
  max-height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.menu-list{
  display: inline-block;
  width: calc(100% - 350px);
  margin-left: 18px;
  height: 80px;
  list-style: none;
}

.menu-list li{
  display: inline-block;
  height: 80px;
  padding: 0 15px;
  float: right;
}

.menu-list li a{
  display: inline-block;
  height: 30px;
  line-height: 30px;
  margin: 25px 0;
  font-size: 16px;
  font-weight: 500;
  color: #797979;
  text-decoration: none;
}

.menu-list li .active{
  color: #0B3777;
}

.menu-list li a:hover{
  color: #0B3777;
}

@media screen and (max-width: 920px){
  .menu-pc{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/MenuPC.vue